import React from 'react';
import { Button, Flex, Modal, Typography } from 'antd';
import theme from '@/utils/themes/Themes.module.scss';
import mcc from '@/components/MainContainer/MainContainerComponents.module.scss';
import { IModalProps } from 'tkmp-lib/src/interfaces';
import { useStores } from '@/utils/hooks/useStores';
import { EProfileType } from 'tkmp-lib/src/enums';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

const ModalUnaccessedDescription = ({ callback_open, callback_close }: IModalProps) => {
    const LOCALIZATION = useLocalization();
    const {
        modalsStore: { openRegisterForm },
        userStore: { USERROLE },
    } = useStores();

    return (
        <Modal
            className={`${theme.GeneralContainer__Theme} ${mcc.modal}`}
            centered
            open={callback_open}
            onCancel={callback_close}
            width={1064}
            okButtonProps={{
                style: { display: 'none' },
            }}
            cancelButtonProps={{
                style: { display: 'none' },
            }}
        >
            <Flex
                vertical
                gap={'32px'}
            >
                <Typography.Text
                    className={`text-32-500 text-[#0B0B0C]`}
                    style={{ textAlign: 'center' }}
                >
                    {(USERROLE as EProfileType) === EProfileType.Distributer
                        ? LOCALIZATION.modals.unaccessedDescription.dearCompany
                        : LOCALIZATION.modals.unaccessedDescription.dearMan}
                    !
                </Typography.Text>
                <Flex
                    style={{
                        height: '88px',
                        padding: '24px',
                        borderRadius: '8px',
                        background: '#F0F3F5',
                    }}
                >
                    <Typography.Text className={`text-16-400 text-[#0B0B0C]`}>
                        {LOCALIZATION.modals.unaccessedDescription.text}
                    </Typography.Text>
                </Flex>
                <Button
                    style={{ width: '316px' }}
                    size={'large'}
                    onClick={() => {
                        callback_close();
                        openRegisterForm();
                    }}
                >
                    {LOCALIZATION.modals.unaccessedDescription.buttonReg}
                </Button>
            </Flex>
        </Modal>
    );
};

export default ModalUnaccessedDescription;
